export const QuestionTableColumnType = {
  LABEL: 'LABEL',
  QUESTION_TEXT: 'QUESTION_TEXT',
  QUESTION_NUMBER_WITH_UNIT: 'QUESTION_NUMBER_WITH_UNIT',
  QUESTION_SINGLE_SELECT: 'QUESTION_SINGLE_SELECT',
} as const

export type QuestionTableColumnType =
  (typeof QuestionTableColumnType)[keyof typeof QuestionTableColumnType]
